<template>
  <base-layout collapsible>
    <router-view />
  </base-layout>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout.vue'

// Both routes under this module (the chat itself and its settings
// dashboard) get the collapse-by-default sidebar — nowhere else in the
// app does, since only this Module.vue passes `collapsible` to BaseLayout.
export default {
  components: { BaseLayout }
}
</script>
